module.exports = __webpack_public_path__ + "static/img/corss_3.d922246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corss_3.png
// module id = 15XE
// module chunks = 1